export const HISTORY_UPDATE_POSITION = 'HISTORY_UPDATE_POSITION';
export const HISTORY_UPDATE = 'HISTORY_UPDATE';
export const HISTORY_PUSH = 'HISTORY_PUSH';
export const HISTORY_RESET = 'HISTORY_RESET';
